import barba from '@barba/core'
import app from '../app/app.js'
import gsap from 'gsap'
import imagesTransitions from './images-transitions.js'

export default {
  init () {
    barba.init({
      prevent: ({ el }) => {
        let prevent = false
        if (el.classList.contains('ab-item')) {
          prevent = true
        }
        if (el.parentElement.classList.contains('lang-item')) {
          prevent = true
        }
        return prevent
      },
      transitions: [
        {
          name: 'default',
          async leave (data) {
            document.body.classList.add('unscrollable')
            const tl = gsap.timeline()

            // image transition
            if (imagesTransitions.active()) {
              imagesTransitions.leave(data)
            }

            tl.to(
              data.current.container,
              {
                opacity: 0,
                duration: 0.5,
                ease: 'power2.inOut'
              },
              0
            )

            return tl.then()
          },
          async enter (data) {
            app.parseComponents(data.next.container)

            const tl = gsap.timeline()

            if (imagesTransitions.active()) {
              const imageTween = imagesTransitions.enter(data)
              if (imageTween) {
                tl.add(imageTween, 0)
              }
            }

            tl.fromTo(
              data.next.container,
              {
                opacity: 0,
                y: '1rem'
              },
              {
                opacity: 1,
                y: 0,
                duration: 0.75,
                delay: 0.5,
                ease: 'power2.inOut',
                clearProps: 'all',
                onComplete: () => {
                  document.dispatchEvent(new CustomEvent('barba.enterComplete'))
                  document.body.classList.remove('unscrollable')
                }
              },
              0
            )

            return tl.then()
          }
        }
      ]
    })
  }
}

barba.hooks.beforeEnter(() => {
  window.scrollTo(0, 0)
})

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
}
